module.exports = __webpack_public_path__ + "img/05_bohle.ec9ecb41.jpeg";